import React from "react";
import { connect } from "react-redux";
import { Button, Modal, Spin, Input, message } from "antd";
import classnames from "classnames";
import { stationgisApi } from "@api/newApi";
import { stationflowchart } from "@api/newApi";
import DropMenu from "./components/DropMenu";
import MyIcon from "../../../components/MyIcon";
import VideoModal from "./components/VideoModal/VideoModal";
import ConfigItemEdit from "./components/ConfigModel/configItemEdit";
import Progress from "./components/Progress/Progress";
import "./assets/style.scss";
import "./index.scss";

// 是否展示参数配置弹窗
class FactoryProgress extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      progressName: "", // 当前厂站名称
      stationId: null, // 当前厂站名称
      videoModalVisble: false, // 监控弹出层visible
      configVisible: false, // 参数设置visibel
      list: [], // 厂站列表
      title: "参数设置", //参数设置弹窗标题
      modalWidth: 592, // 参数设置弹出层宽度
      activeIdx: 0, // 当前编辑的索引
      commandsAll: [], // 详细参数
      rightDatas: [], // 参数设置右侧弹出层参数
      devicesData: [], // 设备数据
      loading: false, // 加载
      currentConfig: null, // 点击时，当前设备
      inputRef: [], // 文本框
    };
  }
  async componentDidMount() {
    // 判断路径是否有传递id
    let searchParams = this.props.location.search
      ? this.props.location.search.split("=")
      : null;
    let id = null;
    if (searchParams) {
      id = searchParams[searchParams.length - 1];
    }
    const { userInfo } = this.props;
    const { data: res } = await stationgisApi.selectGisStationList(
      userInfo.stationIds ? userInfo.stationIds.split(",") : []
    );
    const list = [];
    res.forEach((item) => {
      list.push({
        name: item.aliasName,
        id: item.id,
      });
      if (item.id == id) {
        this.setState({
          stationId: item.id,
          progressName: item.aliasName,
        });
      }
    });
    this.setState({
      stationId: list.length > 0 ? list[0].id : undefined,
      progressName: list.length > 0 ? list[0].name : undefined,
      list,
    });
  }
  // 切换厂站
  changeComponent = (progressName) => {
    this.setState({
      stationId: progressName.split("-")[0],
      progressName: progressName.split("-")[1],
    });
  };

  handleSetLoding = (val) => {
    this.setState({
      loading: val,
    });
  };

  // 匹配字体图标
  getIcon = (item) => {
    let iconStr = "";
    switch (item.processunitName) {
      case "调节池":
        iconStr = "iconicon_gongyidanyuan_tiaojiechi_32";
        break;
      case "污泥池":
        iconStr = "iconicon_gongyidanyuan_wunichi_32";
        break;
      case "格栅":
        iconStr = "iconicon_gongyidanyuan_gezhaqu_32";
        break;
      case "加药间":
        iconStr = "iconicon_gongyidanyuan_jiayaojian_32";
        break;
      case "机电间1":
      case "机电间2":
      case "机电间3":
        iconStr = "iconicon_gongyidanyuan_jidianjian_32";
        break;
      case "厌氧池":
        iconStr = "iconicon_gongyidanyuan_yanyangchi_32";
        break;
      case "好氧池":
        iconStr = "iconicon_gongyidanyuan_haoyangchi_32";
        break;
      case "兼氧池":
        iconStr = "iconicon_gongyidanyuan_jianyangchi_32";
        break;
      case "沉淀池":
        iconStr = "iconicon_gongyidanyuan_chendianchi_32";
        break;
      case "清水池":
        iconStr = "iconicon_gongyidanyuan_qingshuichi_32";
        break;
      case "D型滤池":
        iconStr = "iconicon_gongyidanyuan_Dxinglvchi_32";
        break;
      default:
        iconStr = "iconicon_gongyidanyuan_Dxinglvchi_32";
        break;
    }
    return iconStr;
  };

  // 渲染所有参数左侧信息
  renderAllConfigLeft = (item, index) => {
    return (
      <div
        onClick={() => {
          this.setState({
            activeIdx: index,
            commandsAll: this.state.commandsAll[index].displayVOList,
          });
        }}
        className={classnames({
          "config-left-item": true,
          "active-config": this.state.activeIdx == index,
        })}
        key={"dd" + index}
      >
        <div>
          <MyIcon className="config-icon" type={this.getIcon(item)} />
          <div>{item.processunitName}</div>
        </div>
        {this.state.activeIdx == index && (
          <span className="techProcess-rotate270">
            <MyIcon type="iconxiala" />
          </span>
        )}
      </div>
    );
  };

  // 刷新右侧详细参数信息列表
  refreshCommandsAll = () => {
    this.setState({
      commandsAll: [...this.state.commandsAll],
    });
  };

  // 右侧输入框改变时
  handleInputChange = (value, item) => {
    item.val = value;
    this.refreshCommandsAll();
  };

  // 右侧输入框失去焦点时提交修改
  handleInputBlur = (item) => {
    item.disabled = false;
    let data = {
      gatherDevPointId: item.gatherDevPointId,
      processunitId: this.state.commandsAll[activeIdx].processunitId,
      stationId: this.state.stationId,
      val: item.val * 1,
    };
    this.handleSetLoding(true);
    stationflowchart.update(data).then((res) => {
      this.handleSetLoding(false);
      this.findCommandsByParams(true);
      if (res.status == 0) {
        message.success("修改成功");
      }
    });
  };

  /*
   * @function 渲染右侧详细参数信息
   * item.devTypeAttrValue 后缀包含_C时，为控制开关模块。参数配置页面不做显示
   */
  renderAllConfigRight = (item, index) => {
    let four = item.gatherDevPointValue.split("_")[3];
    if (four != "C") {
      let three = item.gatherDevPointValue.split("_")[2];
      return (
        <div key={"c" + index} className="config-right-item">
          <div className="config-right-title">
            {item.deviceName}
            <span
              className={classnames({
                "status-tip": true,
                red: three == "GZ" && item.val == 1,
              })}
            >
              {three == "GZ" && item.val == 1 ? "异常" : "正常"}
            </span>
          </div>
          <div className="config-right-main">
            <span>{item.gatherDevPointName}</span>
            <div>
              <Input
                disabled={!item.disabled}
                className="config-right-input"
                value={item.val}
                suffix={item.gatherDevPoiParUnit}
                ref={(ref) => {
                  const ls = this.state.inputRef;
                  ls[index] = ref;
                  this.setState({
                    inputRef: ls,
                  });
                }}
                onChange={({ target: { value } }) => {
                  this.handleInputChange(value, item);
                }}
                onBlur={() => {
                  this.handleInputBlur(item);
                }}
              />
              <MyIcon
                onClick={() => {
                  item.disabled = true;
                  if (this.state.inputRef[index]) {
                    setTimeout(() => {
                      this.state.inputRef[index].focus();
                    }, 300);
                  }
                  this.refreshCommandsAll();
                }}
                className="config-icon config-right-icon"
                type="iconxiugai"
                style={{ marginLeft: "16px", cursor: "pointer" }}
              />
            </div>
          </div>
        </div>
      );
    }
  };

  // 查询站点下所有参数配置信息。flag:是否是更新信息后取数据，更新信息后，选中工艺单元不变
  findCommandsByParams = (flag) => {
    stationflowchart
      .findParSetByStationId({ stationId: this.state.stationId })
      .then((res) => {
        if (res.status == 0) {
          this.setState({
            commandsAll: [...res.data],
          });
          if (res.data.length > 0) {
            if (!flag) {
              this.setState({
                activeIdx: 0,
              });
            }
            this.setState({
              rightDatas: [...res.data[activeIdx].displayVOList],
            });
          } else {
            this.setState({
              rightDatas: [],
            });
          }
        }
      });
  };

  goScreen = () => {
    this.props.history.push(`/screen?id=${this.state.stationId}`);
  };

  render() {
    const {
      configVisible,
      stationId,
      currentConfig,
      title,
      loading,
      modalWidth,
      commandsAll,
      rightDatas,
      progressName,
    } = this.state;
    return (
      <div className="factory-progress">
        {/* 下拉菜单 */}
        <DropMenu
          list={this.state.list}
          progressName={progressName}
          changeComponent={this.changeComponent}
        ></DropMenu>
        {/* 流程图 */}
        <div className="factory-content">
          <Progress stationId={stationId}></Progress>
        </div>
        {/* 右侧操作按钮 */}
        <div className="right-btn">
          <Button
            className="operate-btn"
            type="primary"
            style={{ marginRight: 8 }}
            onClick={this.goScreen}
          >
            大屏
          </Button>
          <Button
            className="operate-btn"
            type="primary"
            onClick={() => this.setState({ videoModalVisble: true })}
            icon={<MyIcon type="iconshexiangtou2" />}
          >
            摄像头
          </Button>
        </div>
        {/* 视频监控 */}
        {this.state.videoModalVisble && (
          <VideoModal
            closeModal={() => this.setState({ videoModalVisble: false })}
            videoModalVisble={this.state.videoModalVisble}
            id={this.state.stationId}
            name={this.state.progressName}
          />
        )}
        <Modal
          title={title}
          width={modalWidth}
          className={classnames({
            "config-modal": true,
            "device-modal": title !== "参数设置",
          })}
          destroyOnClose
          open={configVisible}
          onOk={() => this.setState({ configVisible: false })}
          onCancel={() => this.setState({ configVisible: false, activeIdx: 0 })}
          maskClosable={!loading && title == "参数设置"}
          keyboard={false}
        >
          <Spin spinning={loading} tip="正在下发指令,请稍等...">
            {title == "参数设置" && (
              <div className="all-config">
                <div className="all-config-left">
                  {commandsAll &&
                    commandsAll.length > 0 &&
                    commandsAll.map((item, index) => {
                      return renderAllConfigLeft(item, index);
                    })}
                </div>
                <div className="all-config-right">
                  {commandsAll.length == 0 && (
                    <div style={{ color: "#999", textIndent: "98px" }}>
                      - 暂无数据 -
                    </div>
                  )}
                  {rightDatas &&
                    rightDatas.length > 0 &&
                    rightDatas.map((item, index) => {
                      if (item) {
                        return renderAllConfigRight(item, index);
                      }
                    })}
                </div>
              </div>
            )}
            {title !== "参数设置" && (
              <ConfigItemEdit
                id={stationId}
                currentConfig={currentConfig}
                handleSetLoding={this.handleSetLoding}
              />
            )}
          </Spin>
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};
export default connect(mapStateToProps)(FactoryProgress);
